import { stringify } from 'query-string';
import history from 'modules/history';

export const _call = (fn, args) => {
  if (args && typeof args === 'object' && args.query && !args.search) {
    const query = Object.keys(args.query).reduce((acc, key) => {
      if (typeof args.query[key] === 'object') {
        console.error('[utils/routing] Not allowed nested objects.');
        return {
          ...acc,
          [key]: args.query[key].toString(),
        };
      }

      return {
        ...acc,
        [key]: args.query[key],
      };
    }, {});

    const search = stringify(query, { skipNull: true, skipEmptyString: true });

    return fn({
      ...args,
      search,
    });
  }

  return fn(args);
};

export const replaceWithQuery = (args) => _call(history.replace, args);
export const pushWithQuery = (args) => _call(history.push, args);
